import React from "react";
import { h, Component } from "preact";
import ActionButton from "./ActionButton";

class InviteBadge extends Component {
    render() {
        const {
            closeInvite,
            onStart,
            btnText,
            mainText,
            hasAttachment,
            imageUrl,
        } = this.props;

        return (
            <div className="invite-window">
                <ActionButton icon={"icon-times-solid"} onClick={closeInvite} />
                {imageUrl ? (
                    <div className="image-block">
                        <img className={"image"} src={imageUrl} alt="" />
                    </div>
                ) : null}
                <div dangerouslySetInnerHTML={{ __html: mainText }} />
                {hasAttachment ? (
                    <i
                        className={
                            "icon-paperclip-solid icon-size-20 color-gray"
                        }
                    />
                ) : null}
                <button className="start-btn" onClick={onStart}>
                    {btnText}
                </button>
            </div>
        );
    }
}

export default class Invite extends Component {
    render() {
        const {
            invite,
            closeInvite,
            onStart,
            btnText,
            mainText,
            toggleOpen,
            icon,
            hasAttachment,
            imageUrl,
        } = this.props;
        return (
            <div>
                <div>
                    {invite && (
                        <InviteBadge
                            closeInvite={closeInvite}
                            onStart={onStart}
                            btnText={btnText}
                            mainText={mainText}
                            hasAttachment={hasAttachment}
                            imageUrl={imageUrl}
                        />
                    )}
                </div>
                <div
                    onClick={toggleOpen}
                    className={"speech-bubble-wrapper"}
                    style={icon.image_id ? {
                        backgroundImage: `url("${icon.url}")`,
                        backgroundSize: "cover"
                    } : null}
                >
                    {!icon.image_id ?(<i
                        className={`${icon.namespace} fa-${icon.icon} speech-bubble-icon`}
                    />) : null}

                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/app/Invite.js